import { CustomToneMapping, LinearToneMapping, NeutralToneMapping } from '@seddi/three';
import { ToneMapping } from '../rendererTypes';

export const convertToneMapping = (toneMapping: ToneMapping) => {
  switch (toneMapping) {
    case ToneMapping.LINEAR:
      return LinearToneMapping;
    case ToneMapping.NEUTRAL:
      return NeutralToneMapping;
    default:
      return CustomToneMapping;
  }
};
